export enum DocumentPropertyFieldsAreaId {
  Main = 'main',
  Verification = 'verification',
  Publication = 'publication',
  Confirmation = 'confirmation',
  VerificationAssignment = 'verificationAssignment',
  PreVerificationTool = 'preVerificationTool',
  VerifierSelection = 'verifierSelection',
  System = 'system',
}
